import { SelectItem } from "@/components/ui/select";
import { getProfileDisplayName, type AssignableProfile } from "@/hooks/useAssignableProfiles";

interface AssignableUserOptionsProps {
  /** Sentinel value for the "remove assignment" option (Radix forbids ''). */
  unassignValue: string;
  /** Label for the unassign option. */
  unassignLabel: string;
  /** Team-scoped assignable users. */
  users: AssignableProfile[];
}

/**
 * Shared `<SelectItem>` list for assignee pickers (TES-506): the "remove
 * assignment" sentinel followed by one item per assignable user. Reused by the
 * inspection + defect assign dialogs so the option markup lives in one place.
 */
export function AssignableUserOptions({
  unassignValue,
  unassignLabel,
  users,
}: AssignableUserOptionsProps) {
  return (
    <>
      <SelectItem value={unassignValue}>
        <span className="text-warning">{unassignLabel}</span>
      </SelectItem>
      {users.map((assignUser) => (
        <SelectItem key={assignUser.user_id} value={assignUser.user_id} data-sentry-mask>
          {getProfileDisplayName(assignUser)}
        </SelectItem>
      ))}
    </>
  );
}
